import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";

import LogoImg from "../assets/images/fidus logo.png";

const Navbar = () => {
  const location = useLocation();

  const [navbar, setNavbar] = useState(false);

  const changeNaveColor = () => {
    if (window.scrollY >= 200) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeNaveColor);

  return (
    <div
      className={navbar ? "nav-main-container active" : "nav-main-container"}
    >
      <nav className={navbar ? "navbar navbar-expand-sm" : "navbar navbar-expand-sm navbar-dark"}>
        <div className="container-fluid">
          <Link to={"/"} className="navbar-brand">
            <div className="">
              <img src={LogoImg} width="50px" alt="" />
            </div>
            <div className="logo-text">
              <span className="logo-text1">E- Learning </span>
              <span className="logo-text2">with a creative twist</span>
            </div>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mynavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {location.pathname === "/" || location.pathname === "/about" ? (
            <>
              <div className="collapse navbar-collapse" id="mynavbar">
                <ul className="navbar-nav m-auto">
                  <li className="nav-item">
                    {location.pathname === "/" ? (
                      <>
                        <a
                          href="#home"
                          className={
                            location.pathname === "/"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          Home
                        </a>
                      </>
                    ) : (
                      <>
                        <Link
                          to={"/"}
                          className={
                            location.pathname === "/"
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          Home
                        </Link>
                      </>
                    )}
                  </li>

                  <li className="nav-item">
                    <Link
                      to={"/about"}
                      className={
                        location.pathname.includes("/about")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      About
                    </Link>
                  </li>

                  {location.pathname !== "/about" ? (
                    <>
                      <li className="nav-item">
                        <a href="#domains" className="nav-link">
                          Domains
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="#products" className="nav-link">
                          Products
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="#blogs" className="nav-link">
                          Blogs
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="#contact" className="nav-link">
                          Let's Talk
                        </a>
                      </li>
                    </>
                  ) : (
                    <>
                     <li className="nav-item">
                        <a href="/#domains" className="nav-link">
                          Domains
                        </a>
                      </li>
                      <li className="nav-item">
                        <a href="/#products" className="nav-link">
                          Products
                        </a>
                      </li>
                      <li className="nav-item">
                        <Link to={"/blogs"} className="nav-link">Blogs</Link>
                      </li>
                      <li className="nav-item">
                        <a href="/#contact" className="nav-link">
                          Let's Talk
                        </a>
                      </li>
                      </>
                  )}
                </ul>
                <form className="d-flex">
                  <Link to={"/request"}>
                    <button className="btn btn-danger navbtn" type="button">
                      Request Demo
                    </button>
                  </Link>
                </form>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
